// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"b0869336","171":"2cd49e50","453":"d86dc981"}[chunkId] + ".chunk.js";
};